/**
 * WHO-6509. The `checkout` keys the product page reads for the US delivery quote: the note that
 * the buyer pays in euros, under a converted fee. The page doesn't load the whole `checkout`
 * namespace (page weight), only these keys of it.
 */
export const US_DELIVERY_CHECKOUT_NAMESPACE = "checkout";

export const US_DELIVERY_PDP_CHECKOUT_KEYS = ["checkout-converted-total-note"];
